import { Link, useLocation } from 'react-router-dom';

// material-ui
import { ButtonBase, Typography } from '@mui/material';

// project imports
import config from './../../../config';
import Logo from './../../../components/Logo';
import { useSelector } from 'react-redux';
import { ROUTES } from '../../../constants';

//-----------------------|| MAIN LOGO ||-----------------------//

const LogoSection = () => {
    const credential = useSelector((state) => state.auth.credential);
    const location = useLocation();

    const isToiawase = location.pathname === ROUTES.TOIAWASE;
    return (
        <>
            {isToiawase ? (
                <ButtonBase
                    disableRipple
                    component="a"
                    href="https://shirokumapower.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'inline-flex' }}
                >
                    <Logo />
                </ButtonBase>
            ) : (
                <ButtonBase disableRipple component={Link} to={config.defaultPath} sx={{ display: 'inline-flex' }}>
                    <Logo />
                </ButtonBase>
            )}

            <Typography variant="h4" style={{ textAlign: 'center' }}>
                {credential?.shop?.name}
            </Typography>
        </>
    );
};

export default LogoSection;
